import type { AddMembersFromType } from './types';
import { AddMembersFrom } from './types';

interface ChatModal {
  openGroupSetting: boolean;
  openAddMembers: boolean;
  openRemoveMembers: boolean;
  addFrom: AddMembersFromType;
}

type ChatModalActions =
  | {
      type: 'openGroupSetting' | 'openRemoveMembers';
      payload: boolean;
    }
  | {
      type: 'openAddMembers';
      payload: { open: boolean; addFrom?: AddMembersFromType };
    };

function genChatModal(): ChatModal {
  return {
    openGroupSetting: false,
    openAddMembers: false,
    openRemoveMembers: false,
    addFrom: AddMembersFrom.GROUP_INFO,
  };
}
const reducer = (state: ChatModal, action: ChatModalActions) => {
  switch (action.type) {
    case 'openGroupSetting':
      return { ...state, openGroupSetting: action.payload };
    case 'openAddMembers':
      return {
        ...state,
        openAddMembers: action.payload.open,
        addFrom: action.payload.addFrom ?? state.addFrom,
      };
    case 'openRemoveMembers':
      return { ...state, openRemoveMembers: action.payload };
    default:
      return state;
  }
};
export function useChatModal() {
  const [state, dispatch] = useReducer(reducer, genChatModal());

  const setOpenGroupSetting = useCallback((open: boolean) => {
    dispatch({ type: 'openGroupSetting', payload: open });
  }, []);

  const setOpenAddMembers = useCallback(
    (payload: { open: boolean; addFrom?: AddMembersFromType }) => {
      dispatch({ type: 'openAddMembers', payload });
    },
    []
  );

  const setOpenRemoveMembers = useCallback((open: boolean) => {
    dispatch({ type: 'openRemoveMembers', payload: open });
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      setOpenGroupSetting,
      setOpenAddMembers,
      setOpenRemoveMembers,
    }),
    [state, setOpenGroupSetting, setOpenAddMembers, setOpenRemoveMembers]
  );

  return value;
}
